import React, { useEffect, useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CustomLoader from '../../common/CustomLoader';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import {
  validateName,
  validateNameWithNoSpace,
  validateValue,
} from '../../../common/utils/validate';
import CustomRadio from '../../../common/ui/CustomRadio';
import InfoCard from '../../../common/docs/InfoCard';
import { envConstantMsg } from '../../../common/docs/content';
const envConstantSchema = {
  name: '',
  value: '',
  isSameValue: false,
};
const CreateEnvironmentConstant = ({ projectId, appSetting, actions, version, environments }) => {
  const [isSameValue, setIsSameValue] = useState(false);
  const [commonConstantNamesiInEnvs, setCommonConstantNamesiInEnvs] = useState([]);
  const { addEnvConstantPending } = appSetting;

  const getCommonConstantNamesInEveryEnv = (environments) => {
    return environments.reduce(
      (acc, env) => {
        const currentCnstNames = env.constants.map((c) => c.name);
        return acc.filter((cnst) => currentCnstNames.includes(cnst));
      },
      environments[0].constants.map((c) => c.name),
    );
  };

  useEffect(() => {
    const commonConstantNames = getCommonConstantNamesInEveryEnv(environments);
    setCommonConstantNamesiInEnvs(commonConstantNames);
  }, [environments]);

  const handleSubmit = (values) => {
    actions.addEnvConstant({ projectId, version, ...values });
  };

  const validateNameToExistConstantName = (value) => {
    const isValidName = validateNameWithNoSpace(value);
    if (isValidName) return isValidName;
    if (commonConstantNamesiInEnvs.includes(value))
      return 'Variable with this name already exist in every environment';
  };

  return (
    <Formik
      initialValues={envConstantSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
        setSubmitting(false);
        resetForm();
      }}
    >
      {({ isSubmitting, resetForm, errors }) => {
        return (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon required={true} icon="text" title="Name of Variable">
                  <Field
                    type="text"
                    name="name"
                    className="form-control form-control-sm"
                    placeholder="Name of Variable"
                    validate={validateNameToExistConstantName}
                  />
                  <ErrorMessage name="name">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
                <div className="ml-5">
                  <small className="field-detail">{envConstantMsg}</small>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon required={true} icon="text">
                  <Field
                    type="text"
                    name="value"
                    validate={validateValue}
                    className="form-control form-control-sm"
                    placeholder="Value"
                  />
                  <ErrorMessage name="value">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-check ml-4">
                  <CustomRadio
                    label="Use the same value for all existing environment"
                    isRadio={false}
                  >
                    <Field type="checkbox" name="isSameValue" className="form-check-input" />
                  </CustomRadio>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 mt-2 text-right">
                <button type="button" className="btn btn-default btn-md" onClick={resetForm}>
                  <span>
                    <i className={`wb ${drapcodeIcon('clear')}`}></i>&nbsp;Clear
                  </span>
                </button>
                &nbsp;
                <button
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                  disabled={isSubmitting && addEnvConstantPending ? 'disabled' : ''}
                >
                  <i className="wb webconnect-plus"></i>&nbsp; Create &nbsp;
                  <CustomLoader loading={addEnvConstantPending} />
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEnvironmentConstant;
